export const DEFAULT_EXTRA_SETTINGS_MAP = {
  "two_factor": {
    key: "two_factor",
    value: "İki Adımlı Doğrulama",
    fields: null,
    enabled: true
  },
  "sms_validation": {
    key: "sms_validation",
    value: "SMS ile islem Dogrulama",
    fields: null,
    enabled: true
  },
  "force_reset_password": {
    key: "force_reset_password",
    value: "Şifre sıfırlamaya zorla",
    fields: [
      {
        key: "start_date",
        label: "Başlangıç Tarihi",
        type: "DATE",
        value: null
      }
    ],
    enabled: false
  },
  "danger_sms_validation": {
    key: "danger_sms_validation",
    value: "Tehlikeli Mesaj Kontrolü",
    fields: null,
    enabled: true
  }
};

export const mergeExtraSettings = (serverSettings = []) => {
  if (!Array.isArray(serverSettings)) {
    return [];
  }

  const mergedSettings = serverSettings.map(serverSetting => {
    const defaultSetting = DEFAULT_EXTRA_SETTINGS_MAP[serverSetting.key];
    
    if (defaultSetting) {
      let mergedFields = serverSetting.fields;
      
      if (defaultSetting.fields && defaultSetting.fields.length > 0) {
        if (!serverSetting.fields || !Array.isArray(serverSetting.fields)) {
          mergedFields = defaultSetting.fields.map(field => ({ ...field }));
        } else {
          mergedFields = defaultSetting.fields.map(defaultField => {
            const serverField = serverSetting.fields.find(f => f.key === defaultField.key);
            if (serverField) {
              return {
                ...defaultField,
                ...serverField
              };
            }
            return { ...defaultField };
          });
          
          const extraServerFields = serverSetting.fields.filter(
            serverField => !defaultSetting.fields.find(df => df.key === serverField.key)
          );
          mergedFields = [...mergedFields, ...extraServerFields];
        }
      }
      
      return {
        ...defaultSetting, 
        ...serverSetting,
        fields: mergedFields
      };
    }
    
    return serverSetting;
  });
  
  Object.keys(DEFAULT_EXTRA_SETTINGS_MAP).forEach(key => {
    if (!mergedSettings.find(s => s.key === key)) {
      mergedSettings.push({ ...DEFAULT_EXTRA_SETTINGS_MAP[key] });
    }
  });
  
  return mergedSettings;
};